import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

export class ClearMessagesService {

  private data$ = new BehaviorSubject<boolean>(null);
  clearMessage = this.data$.asObservable();

  public getClearMessages(): Observable<boolean> {
    return this.clearMessage;
  }

  public setClearMessages(clearFlag: boolean) {
    this.data$.next(clearFlag);
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/shared/clear-messages.service.ts